<template>
  <div class="navigation-accordion-shell" :class="{ 'navigation-accordion-shell--is-open': isOpen }">
    <button ref="togglerButton" class="navigational-item navigational-item--gray navigational-item--dark-blue" @click="toggleAccordion()">
      <slot name="toggler"></slot>
      <oie-use-svg :svg="isOpen ? 'circle-down' : 'circle-caret'" class="navigation-item__icon-right"></oie-use-svg>
    </button>

    <div v-if="isOpen" class="navigation-accordion-shell__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import accordionMixin from '@/mixins/accordion.js'

export default {
  mixins: [accordionMixin],
  props: {
    customToggleEvent: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if(this.customToggleEvent) {
      this.subscribe(this.customToggleEvent, () => {
        this.$refs.togglerButton.focus()
        this.toggleAccordion()
      })
    }
  }
}
</script>

<style lang="scss">
.navigation-accordion-shell {
  border: 1px solid transparent;
}

.navigation-accordion-shell--is-open {
  border-color: color(blue-1);
}

.navigation-accordion-shell__content {
  background-color: #3B3B3B;
  overflow: hidden;
}
</style>
